import React from 'react';
import FilterPillSlider from './FilterPillSlider.tsx';
import { MARKS_BUCKETS, MARKS_BUCKET_LABELS, MarksBucket } from './marks.ts';

type MarksSelectProps = {
  value: MarksBucket | null;
  onChange: (value: MarksBucket | null) => void;
  disabled?: boolean;
};

const MarksSelect: React.FC<MarksSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <FilterPillSlider
    title="Marks"
    levels={MARKS_BUCKETS}
    labels={MARKS_BUCKET_LABELS}
    value={value}
    onChange={onChange}
    disabled={disabled}
  />
);

export default MarksSelect;
